import type { FC } from "react";

import { AnimatedNumber } from "@ui/components/AnimatedNumber";
import classNames from "classnames";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { Button } from "@jti/core-components/components/Button";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import type { ReferralStatsCardProps } from "./ReferralStatsCard.types";

import styles from "./ReferralStatsCard.module.scss";

export const ReferralStatsCard: FC<ReferralStatsCardProps> = ({
  count,
  headerText,
  isRedirect,
  isReferralCTA,
  informationText,
  additionalText,
  badgeText,
  href,
  ctaButtonText,
  isAllAchievementsDone = false,
  isAnimatedNumberEnabled = false,
}) => {
  const isCountNaN = Number.isNaN(Number(count));

  const handleAdditionalButtonClick = () => {
    dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
      cta_name: ctaButtonText ?? "",
      cta_location: "referral-stats-card",
    });
  };

  return (
    <div
      data-testid="referralStatsCardWrapper"
      className={classNames(styles.statisticCardWrapper, { [styles.referralCTAWrapper]: isReferralCTA })}
    >
      {isCountNaN ? (
        <h2 className={styles.statsItemAmount}>{count}</h2>
      ) : (
        <AnimatedNumber
          numberToAnimate={Number(count)}
          containerClassName={styles.animationWrapper}
          textClassName={styles.statsItemAmount}
          isAnimationDisabled={!isAnimatedNumberEnabled}
        />
      )}
      <h4
        className={classNames(styles.statsItemDescription, {
          [styles.statsItemDescriptionDone]: isAllAchievementsDone,
        })}
      >
        {headerText}
      </h4>
      <div className={classNames(styles.additionalInfo, { "dark-theme": !isReferralCTA })}>
        {!isRedirect && (
          <>
            <p className={styles.additionalInfoHeading}>
              {informationText}
              <span className={styles.additionalInfoBadge}>{badgeText}</span>
            </p>
            <p className={styles.additionalInfoSubtext}>{additionalText}</p>
          </>
        )}

        {isRedirect && !isAllAchievementsDone && (
          <Button
            className={styles.additionalInfoRedirect}
            href={href}
            size="sm"
            variant="text-muted"
            onClick={handleAdditionalButtonClick}
            data-testid="additionalButton"
            iconAfter={LongArrowForwardIcon}
          >
            {ctaButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};
